import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useAddressEditor } from "../../hooks/useAddressEditor";
import AddressEditorView from "./AddressEditorView";

export default function AddressEditor({ userID, uniqueKey, onDone }) {
    const {
        loading,
        originalAddress,
        editedAddress,
        setEditedAddress,
        status,
        validationError,
        isDeleted,
        handleSave,
    } = useAddressEditor(userID, uniqueKey, onDone);

    const handleEditAddress = useCallback(
        (val) => setEditedAddress(val),
        [setEditedAddress]
    );

    const handleBack = useCallback(
        () => onDone?.(null),
        [onDone]
    );

    return (
        <AddressEditorView
            loading={loading}
            originalAddress={originalAddress}
            editedAddress={editedAddress}
            status={status}
            validationError={validationError}
            isDeleted={isDeleted}
            onEditAddress={handleEditAddress}
            onSave={handleSave}
            onBack={handleBack}
        />
    );
}

AddressEditor.propTypes = {
    userID: PropTypes.string.isRequired,
    uniqueKey: PropTypes.string.isRequired,
    onDone: PropTypes.func,
};
